const textWrap = {
  name: "text-wrap",
  path: "/text-wrap",
  title: "text-wrap",
  description: "Utilities for controlling how text wraps within an element.",
  value: {
    "text-wrap": {
      "text-wrap": "wrap",
      "text-nowrap": "nowrap",
      "text-balance": "balance",
      "text-pretty": "pretty"
    }
  },
  exampleData: [
    {
      example: {
        code: `
<p class="text-wrap w-48">The quick brown fox jumps over the lazy dog. The quick brown fox jumps over the lazy dog.</p>
<p class="text-nowrap w-48">The quick brown fox jumps over the lazy dog. The quick brown fox jumps over the lazy dog.</p>
<p class="text-balance w-48">The quick brown fox jumps over the lazy dog. The quick brown fox jumps over the lazy dog.</p>
<p class="text-pretty w-48">The quick brown fox jumps over the lazy dog. The quick brown fox jumps over the lazy dog.</p>
        `
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">text-wrap</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">text-nowrap</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">text-base</code>, or <code class="text-color-gray-800 dark:text-color-white font-semibold">text-pretty</code> to control text wrapping.
      </p>
      <div class="space-y-6">
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">text-wrap</small>
          <p class="text-wrap">New Yorkers are facing the winter chill with less warmth this year as the city's most revered soup stand unexpectedly shutters, following a series of events that have left the community puzzled.</p>
        </div>
        <div class="overflow-hidden">
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">text-nowrap</small>
          <p class="text-nowrap">New Yorkers are facing the winter chill with less warmth this year as the city's most revered soup stand unexpectedly shutters, following a series of events that have left the community puzzled.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">text-balance</small>
          <p class="text-balance">New Yorkers are facing the winter chill with less warmth this year as the city's most revered soup stand unexpectedly shutters, following a series of events that have left the community puzzled.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">text-pretty</small>
          <p class="text-pretty">New Yorkers are facing the winter chill with less warmth this year as the city's most revered soup stand unexpectedly shutters, following a series of events that have left the community puzzled.</p>
        </div>
      </div>
      `
    }
  ]
};

export default textWrap;
<div className="text-wrap text-nowrap text-balance text-pretty sr-only"></div>